import { render, staticRenderFns } from "./MetricTrendWidget.vue?vue&type=template&id=519cd414&scoped=true"
import script from "./MetricTrendWidget.vue?vue&type=script&lang=ts"
export * from "./MetricTrendWidget.vue?vue&type=script&lang=ts"
import style0 from "./MetricTrendWidget.vue?vue&type=style&index=0&id=519cd414&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519cd414",
  null
  
)

export default component.exports